<template>
  <v-text-field
    v-model="inputPassword"
    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
    @click:append="() => (showPassword = !showPassword)"
    :type="showPassword ? 'text' : 'password'"
    :id="id"
    required
    solo
    flat
    clearable
    :style="{
      width: width + 'px'
    }"
  ></v-text-field>
</template>

<script>
export default {
  name: 'PasswordInput',
  model: { prop: 'passwordText', event: 'input' },
  props: {
    id: { type: String, required: false },
    passwordText: { type: String, required: true },
    width: {
      type: [Number, String],
      required: false,
      default: 196
    }
  },
  data() {
    return {
      showPassword: false
    };
  },
  computed: {
    inputPassword: {
      get() {
        return this.passwordText;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style scoped>
.v-toolbar {
  display: none;
}
.v-input >>> .v-input__control .v-input__slot .v-text-field__slot input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  -o-box-shadow: 0 0 0px 1000px white inset;
  -ms-box-shadow: 0 0 0px 1000px white inset;
  -moz-box-shadow: 0 0 0px 1000px white inset;
}
/* Form */
.v-input >>> .v-input__control .v-input__slot {
  border-radius: 5px;
  border: solid 1px #ced6e0;
}
.v-input >>> .v-input__control .v-input__slot:before {
  display: none;
}
.v-input >>> .v-input__control .v-input__slot .v-text-field__slot input {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/_atoms/inputs/PasswordInput.vue